export type SearchGroup = 'Services' | 'Window and door options' | 'Areas we serve' | 'Articles' | 'Questions and answers' | 'Pages'

export interface SearchResult {
    id: string
    group: SearchGroup
    title: string
    url: string
    snippet: string
}

export interface SearchResponse {
    query: string
    total: number
    results: SearchResult[]
    interior: boolean
    terms: string[]
}

export const POPULAR_SEARCHES = [
    "Window replacement cost",
    "Entry doors",
    "Storm doors",
    "Black streaks on roof",
    "Fiber cement siding",
    "Areas you serve"
]

export const GROUP_ORDER: SearchGroup[] = [
    'Services',
    'Window and door options',
    'Areas we serve',
    'Questions and answers',
    'Articles',
    'Pages'
]
